import type { IMenuSessionStore } from './IMenuSessionStore';

/** Скільки останніх переходів-відкриттів пам'ятати (Назад браузера до них не скидає меню); старіші забуваються. */
const VISITS_KEPT = 200;

/**
 * Сховище розгорнутості розділів меню модуля, які прототип v4 тримає лише в стані сеансу (navCollapsed з ключами
 * /_(settings|records)$|^rt_|^md_/): у пам'яті вкладки, тож воно переживає вихід із модуля («Відкрити модуль» у Налаштуваннях, «Назад»
 * браузера) і скидається перезавантаженням сторінки (прототип вилучає ці ключі, коли завантажує стан). Нове відкриття модуля (openModule —
 * перехід на корінь модуля) очищує всі слоти — один раз на перехід історії (`visit`), тож повернення «Назад» до того самого переходу стан не
 * скидає. Знімок незмінний: кожна зміна дає новий об'єкт (useSyncExternalStore).
 */
export function createMenuSessionStore(): IMenuSessionStore {
  let state: Readonly<Record<string, boolean>> = {};
  const visits = new Set<string>();
  const listeners = new Set<() => void>();
  const emit = () => listeners.forEach((l) => l());
  return {
    subscribe: (listener) => { listeners.add(listener); return () => { listeners.delete(listener); }; },
    snapshot: () => state,
    isOpened: (visit) => visits.has(visit),
    set: (slot, value) => {
      if (state[slot] === value) return;
      state = { ...state, [slot]: value };
      emit();
    },
    open: (visit) => {
      if (visits.has(visit)) return;
      visits.add(visit);
      if (visits.size > VISITS_KEPT) visits.delete(visits.values().next().value as string);
      if (!Object.keys(state).length) return;
      state = {};
      emit();
    },
  };
}

/** Спільне сховище вкладки (одне на застосунок, як navCollapsed прототипу). */
export const menuSession = createMenuSessionStore();
